import CityPageTemplate from "../city-template/CityPageTemplate";
import { middletownConfig } from "./data";

export default function MiddletownPage() {
  return <CityPageTemplate config={middletownConfig} />;
}